import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import {flatMap, withLatestFrom} from 'rxjs/operators';
import * as actionsUi from './mandantenverwaltung-einstellungen.actions.ui';
import {UuidService} from '@orga-app/providers/uuid.service';
import {MandantenConfigTypes, PandemieConfigTypes, VeranstaltungConfigTypes, VorlagenConfigTypes, IncidentsConfigTypes} from '../../../client-constants';
import MANDANT_STAMM_OPTIONS = MandantenConfigTypes.MANDANT_STAMM_OPTIONS;
import LIZENZ_MANDANT_OPTIONS = MandantenConfigTypes.LIZENZ_MANDANT_OPTIONS;
import MANDANT_INFO = MandantenConfigTypes.MANDANT_INFO;
import VORLAGEN_MANDANT_OPTIONS = VorlagenConfigTypes.VORLAGEN_MANDANT_OPTIONS;
import VERANSTALTUNGEN_MANDANT_OPTIONS = VeranstaltungConfigTypes.VERANSTALTUNGEN_MANDANT_OPTIONS;
import PANDEMIE_MANDANT_OPTIONS = PandemieConfigTypes.PANDEMIE_MANDANT_OPTIONS;
import INCIDENTS_ANZEIGE_MANDANT_OPTIONS = IncidentsConfigTypes.INCIDENTS_ANZEIGE_MANDANT_OPTIONS;
import {GetMandantConfigAction, GetMandantLogoBase64ScaledAction, PostMandantConfigSpeichernAction} from '../../../client-ngrx/api';
import {GetFunktionsbereicheRollenAdminAction} from '../../../client-ngrx/benutzerverwaltung';
import {getIncidentAnzeigeConfig, getPandemieConfig, getStammConfig, getVeranstaltungenConfig, getVorlagenConfig} from './mandantenverwaltung-einstellungen.selectors';
import {MandantConfigRequest} from '../../../clients/api';
import {PageState} from './mandantenverwaltung-einstellungen.reducer';

@Injectable()
export class MandantenverwaltungEinstellungenPageUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , flatMap(() => {
            return [new GetMandantConfigAction(MANDANT_STAMM_OPTIONS + ';' +
                LIZENZ_MANDANT_OPTIONS + ';' +
                MANDANT_INFO + ';' +
                VORLAGEN_MANDANT_OPTIONS + ';' +
                VERANSTALTUNGEN_MANDANT_OPTIONS + ';' +
                PANDEMIE_MANDANT_OPTIONS + ';' +
                INCIDENTS_ANZEIGE_MANDANT_OPTIONS
            ),
                new GetFunktionsbereicheRollenAdminAction(),
            new GetMandantLogoBase64ScaledAction(80, 80)];
        })
    );

    @Effect()
    mandantenEinstellungenSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.MANDANTEN_EINSTELLUNGEN_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getStammConfig)),
            this.store.pipe(select(getVorlagenConfig)),
            this.store.pipe(select(getVeranstaltungenConfig)),
            this.store.pipe(select(getPandemieConfig)),
            this.store.pipe(select(getIncidentAnzeigeConfig)))
        , flatMap(([x, stamm, vorlagen, veranstaltungen, pandemie, incident]) => {
            const configs: { [key: string]: any } = {};

            if (stamm !== null) {
                configs['stamm'] = stamm;
            }
            if (vorlagen !== null) {
                configs['vorl-vorlagen'] = vorlagen;
            }
            if (veranstaltungen !== null) {
                configs['ver-veranstaltungen'] = veranstaltungen;
            }
            if (pandemie !== null) {
                configs['pan-pandemie'] = pandemie;
            }
            if (incident !== null) {
                configs[INCIDENTS_ANZEIGE_MANDANT_OPTIONS] = incident;
            }

            const request: MandantConfigRequest = {
                configs,
            };
            return [new PostMandantConfigSpeichernAction(request)];
        })
    );


    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private uuid: UuidService) {
    }
}
